import React from 'react';
import { FormInstance } from 'antd/lib/form';
import SpaceDescriptions from '../../../../common/Layout/SpaceDescriptions';
import AppDivider from '../../../../common/AppDivider';
import { TopologyItem } from '../../../Topology/TopologyItem';

export type ImportKeepalivedPreviewProps = {
    form: FormInstance;
};

export default ImportKeepalivedPreview;

function ImportKeepalivedPreview({ form }: ImportKeepalivedPreviewProps) {
    const { keepalivedConfiguration, keepalivedHost } = form.getFieldsValue(
        true
    );
    return (
        <div>
            <SpaceDescriptions
                direction="vertical"
                title="Configuration"
                size="small"
                alignItems="right"
            >
                {Array.isArray(keepalivedConfiguration.hostname) &&
                    keepalivedConfiguration.hostname.map(
                        (topology: TopologyItem, index: number) => {
                            return (
                                <SpaceDescriptions.Item
                                    key={index}
                                    labelMuted
                                    label={`Keepalived ${index + 1}`}
                                >
                                    {topology?.extraData.hostname ?? ''}
                                </SpaceDescriptions.Item>
                            );
                        }
                    )}
            </SpaceDescriptions>
            <AppDivider />
            <SpaceDescriptions
                direction="vertical"
                title="Host configuration"
                size="small"
                alignItems="right"
            >
                <SpaceDescriptions.Item label="Virtual IP">
                    {`${keepalivedHost?.virtualIP ?? ''}`}
                </SpaceDescriptions.Item>
            </SpaceDescriptions>
        </div>
    );
}
